// Environment variables with validation
function getRequiredEnv(key: string): string {
  const value = import.meta.env[key]
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`)
  }
  return value
}

// Validated environment variables
export const env = {
  API_URL: getRequiredEnv('VITE_API_URL'),
  ENVIRONMENT: getRequiredEnv('VITE_ENVIRONMENT'),
} as const 